import type { Word } from '@/types';

export const WORDS: Word[] = [
  { id: 1, word: 'TURNING', hiddenInBackground: false }, // From the physical scratch card
  { id: 2, word: 'GOOD', hiddenInBackground: true },
  { id: 3, word: 'IDEAS', hiddenInBackground: true },
  { id: 4, word: 'INTO', hiddenInBackground: true },
  { id: 5, word: 'GREAT', hiddenInBackground: false }, // From the physical scratch card
  { id: 6, word: 'PRODUCTS', hiddenInBackground: true },
];

export const REVEAL_RADIUS = 100;

export const BUTTON_APPEAR_DELAY = 1500;
